import gmx_zMixins         from '../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_Elements from './Elements.mixin'          // Common functions for Drawing the Charts & Tables
import lmx_Header from './Draw_Header.mixin'          //Drawing the Header in Table
import lmx_DataCells from './Draw_DataCells.mixin'          //Drawing the Header in Table
import lmx_Footer from './Draw_Footer.mixin'
import lmx_TableLines from './Draw_TableLines.mixin'

import lmx_Coloring from './Style_Coloring.mixin'
import lmx_BarChart from './Style_BarChart.mixin'
import lmx_Icons from './Style_Icons.mixin'
import lmx_Text from './Style_Text.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins
    lmx_Elements,
    lmx_Header,
    lmx_DataCells,
    lmx_Footer,
    lmx_TableLines,
    
    lmx_Text,
    lmx_Coloring,
    lmx_BarChart,
    lmx_Icons,

  ],
}
